import { DeviceTypes } from "../apiTypes";
import { faro } from "@grafana/faro-web-sdk";

export const deviceLinkLocalhostRoot = 'http://localhost:53211/api/v1';

export interface About {
    machineName: string;
    operatingSystem: string;
    architecture: string;
    framework: string;
    timeZone: string;
    utcOffset: string;
    serviceName: string;
    vendor: string;
    connection: string;
    version: string;
    isUpdatePending: boolean;
    environment: string;
    status: string;
}

export interface Update {
    id: string;
    version: string;
    fileSize: number;
    isDelta: boolean;
}

export interface Device {
    id: string;
    type: DeviceTypes;
    name: string;
    vendor: string;
    hardware: string;
    firmware: string;
    serial: string;
    connection: string;
    status: string;
}

export interface IsSuccessResult {
    isSuccess: boolean;
}

export const ApiAbout = (): Promise<About> => {
    return faroFetch(`${deviceLinkLocalhostRoot}/about`, {
        method: 'GET',
        headers: {
            'content-type': 'application/json',
        },
    })
    .then(response => response.json())
}

export const ApiUpdates = (): Promise<Update> => {
    return faroFetch(`${deviceLinkLocalhostRoot}/updates`, {
        method: 'GET',
        headers: {
            'content-type': 'application/json',
        },
    })
        .then(response => response.json());
}

export const ApiUpdatesApply = (): Promise<boolean> => {
    return faroFetch(`${deviceLinkLocalhostRoot}/updates/apply`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
        },
    })
        .then(response => response.ok);
}

export const ApiDevices = (): Promise<Array<Device>> => {
    return faroFetch(`${deviceLinkLocalhostRoot}/devices`, {
        method: 'GET',
        headers: {
            'content-type': 'application/json',
        },
    })
        .then(response => response.json())
}

export const faroFetch = async (url, init?: RequestInit) => {
    const response = await fetch(url, init);

    if (!response.ok) {
        let body;
        if (response.headers.get("content-type") && response.headers.get("content-type").indexOf("application/json") !== -1) {
            body = await response.json();
        } else {
            body = await response.text();
        }

        const error = new Error(body.error ?? body.title);

        if (faro.api === undefined) {
            throw error;
        }

        faro.api.pushError(error, {
            context: {
                url,
                status: response.status.toString(),
                method: init.method || 'GET',
                body,
            },
        });

        throw error;
    }

    return response;
}
